const TickBoxIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.33203 0.333374C1.23506 0.333374 0.332031 1.2364 0.332031 2.33337V11.6667C0.332031 12.7637 1.23506 13.6667 2.33203 13.6667H11.6654C12.7623 13.6667 13.6654 12.7637 13.6654 11.6667V6.33337H12.332V11.6667C12.332 12.0364 12.0351 12.3334 11.6654 12.3334H2.33203C1.96233 12.3334 1.66536 12.0364 1.66536 11.6667V2.33337C1.66536 1.96368 1.96233 1.66671 2.33203 1.66671H8.33203V0.333374H2.33203ZM12.6471 1.60942L6.45182 8.17712L4.00391 5.72921L3.0612 6.67191L6.47917 10.0899L13.6172 2.52478L12.6471 1.60942Z"
        fill="#585757"
      />
    </svg>
  );
};

export default TickBoxIcon;
